import { Controller } from "stimulus"
export default class extends Controller {

    //static targets = [ "service" ]

    //connect() {
    //    console.log("Connected! MyColors....")
    //}

    get_collection(event) {
        
        let formData = new FormData()
        //formData.append("discontinued", this.discontinuedTarget.checked);

        fetch(this.data.get("update-url"), {
//            body: formData,
            method: 'GET',
            credentials: "include",
            dataType: "script",
            headers: {
                    "X-CSRF-Token": document.getElementsByName("csrf-token")[0].content 
             },
        }).then(response => response.text()).then(html => {
            // console.log(html);
            $("#initial_search_collection").toggleClass('d-none');
            document.getElementById('product-assortiment').innerHTML = html;

            //initToolTips(); // Initialize tooltips after new content is added
        }).catch((err) => console.log("Can’t access response. Blocked by browser?" + err));

    }

    filter_collection(event) {
        if (event && typeof event.preventDefault === "function") {
          event.preventDefault();
        }

        // Get all the select elements
        let statementSelect = document.getElementById('statement'); // Optional filter
        let seizoenSelect = document.getElementById('season'); // Ensure this is the correct ID
        let colorSelect = document.getElementById('color'); // Ensure this is the correct ID
        let occasionSelect = document.getElementById('occasion'); // Ensure this is the correct ID
        let labelInput = document.getElementById('label-search'); // Datalist-backed input for labels

        // Construct the query string with the selected parameter
        let selectedValue = event.target.value ? event.target.value.trim() : "";
        if (event.target.value !== selectedValue) {
          event.target.value = selectedValue;
        }
  
        const normalizeValue = (element) => {
            if (!element || typeof element.value !== "string") {
                return "";
            }
            const value = element.value.trim();
            if (element.value !== value) {
                element.value = value;
            }
            return value;
        };

        const queryParams = {};
        const activeFilters = {
            statement: normalizeValue(statementSelect),
            season: normalizeValue(seizoenSelect),
            color: normalizeValue(colorSelect),
            occasion: normalizeValue(occasionSelect),
            label: normalizeValue(labelInput)
        };

        Object.entries(activeFilters).forEach(([key, value]) => {
            if (value) {
                queryParams[key] = value;
            }
        });

        this.loadProducts(queryParams);
    }
      

    resetFilters(event) {
        event.preventDefault();
        const filters = ["statement", "season", "color", "occasion"];

        filters.forEach((name) => {
            const input = document.getElementById(name);
            if (input) {
                input.value = '';
            }
        });

        const labelInput = document.getElementById('label-search');
        if (labelInput) {
            labelInput.value = '';
        }

        this.loadProducts({});
    }

    select_swatch(event) {

        const swatchId = event.currentTarget.dataset.mycolorsSwatchValue;
        if (!swatchId) {
            return;
        }

        fetch(this.data.get("update-url")+"/"+swatchId, {
            method: 'GET',
            credentials: "include",
            dataType: "script",
            headers: {
                    "X-CSRF-Token": document.getElementsByName("csrf-token")[0].content 
                },
        }).then(response => response.text()).then(html => {

            //let divElement = document.getElementById("selected-swatch");
            //let elemHeight = divElement.offsetHeight;
            //if(elemHeight>0) {
             //   divElement.style.cssText = "min-height: " + elemHeight + "px;";
            //}
//debugger;
         //   document.getElementById('product_on_label').value = "";
            document.getElementById('selected-swatch').innerHTML = html;

            initToolTips(); // Initialize tooltips after new content is added
        }).catch((err) => console.log("Can’t access response. Blocked by browser?" + err));
    }

    select_swatch_on_label(event) {
        //alert(document.getElementById('formSwatchLabelRange').value);

        fetch(this.data.get("update-url")+"/"+document.getElementById('product_on_label').value, {
            method: 'GET',
            credentials: "include",
            dataType: "script",
            headers: {
                    "X-CSRF-Token": document.getElementsByName("csrf-token")[0].content 
                },
        }).then(response => response.text()).then(html => {

            let divElement = document.getElementById("selected-swatch");
            let elemHeight = divElement.offsetHeight;
            if(elemHeight>0) {
              //  divElement.style.cssText = "min-height: " + elemHeight + "px;";
            }

            document.getElementById('selected-swatch').innerHTML = html;

            initToolTips(); // Initialize tooltips after new content is added
        }).catch((err) => console.log("Can’t access response. Blocked by browser?" + err));
    }

    prevent_submit(event) {
        if (!event) { return; }
        event.preventDefault();
        event.stopPropagation();
    }

    handle_label_keydown(event) {
        if (event.key === "Enter") {
            event.preventDefault();
            this.filter_collection(event);
        }
    }

    loadProducts(queryParams) {
        let url = this.data.get("update-url");

        const params = new URLSearchParams(queryParams || {});
        const queryString = params.toString();

        if (queryString.length > 0) {
            url += "?" + queryString;
        }

        fetch(url, {
            method: 'GET',
            credentials: "include",
            headers: {
                "X-CSRF-Token": document.getElementsByName("csrf-token")[0].content 
            },
        }).then(response => response.text()).then(html => {
            document.getElementById('product-assortiment').innerHTML = html;

            if (typeof initToolTips === "function") {
                initToolTips();
            }
        }).catch((err) => console.log("Can’t access response. Blocked by browser?" + err));
    }

}
